import { useQuery } from 'react-query';

import { getNotificationStatus as queryFn } from 'api/endPoints/getNotificationStatus';

export const useQueryGetNotificationsConnectionStatus = () => {
    return useQuery<boolean, QueryError>('useQueryGetNotificationsConnectionStatus', queryFn, {
        placeholderData: true,
    });
};
